module.exports = __webpack_public_path__ + "static/averta-semibold-d8739a684bd42e83dfc6e6786837cb59.woff";